
export interface SettingsNavItem {
  name: string;
  label: string;
  icon: string;
  active: string[];
  permission?: string;
  requiresEcommerce?: boolean;
  requiresPublishedMainEcommerce?: boolean;
}

export const SETTINGS_NAV_ITEMS: SettingsNavItem[] = [
  { name: 'SettingsGeneral', label: 'Général', icon: 'fa fa-sliders', active: ['SettingsGeneral'] },
  { name: 'SettingsPrinting', label: 'Impression', icon: 'fa fa-print', active: ['SettingsPrinting'] },
  { name: 'SettingsInventory', label: 'Inventaire', icon: 'fa fa-boxes-stacked', active: ['SettingsInventory'], permission: 'inventories.view' },
  { name: 'SettingsAccounting', label: 'Comptabilité', icon: 'fa fa-scale-balanced', active: ['SettingsAccounting'] },
  { name: 'SettingsEcommerce', label: 'E-commerce', icon: 'fa fa-bag-shopping', active: ['SettingsEcommerce'], requiresEcommerce: true, requiresPublishedMainEcommerce: true },
  { name: 'ShopInfo', label: 'Infos boutique', icon: 'fa fa-store', active: ['ShopInfo'] },
  { name: 'DeliverySettings', label: 'Réglages des livraisons', icon: 'fa fa-truck', active: ['DeliverySettings'], requiresEcommerce: true },
  { name: 'MovementSettings', label: 'Réglages mouvements', icon: 'fa fa-right-left', active: ['MovementSettings'] },
  { name: 'ExpenseTypes', label: 'Types de dépenses', icon: 'fa fa-tags', active: ['ExpenseTypes'], permission: 'expenses.manage_types' },
];

export const visibleSettingsNavItems = (
  ecommerceEnabled = true,
  ecommerceSettingsAccessible = ecommerceEnabled
): SettingsNavItem[] => SETTINGS_NAV_ITEMS.filter((item) => {
  if (item.requiresEcommerce && !ecommerceEnabled) return false;
  if (item.requiresPublishedMainEcommerce && !ecommerceSettingsAccessible) return false;

  return true;
});
